import React__default from 'react';
import Card from '../../../../Atoms/Card.js';

var arrayMap = Array(4).fill(0);
function OrderStatusPreviewShimmer() {
    return (React__default.createElement(Card, { classes: "order_status_preview" }, arrayMap.map(function (e) { return (React__default.createElement("div", { className: "order_status_preview__item", key: e },
        React__default.createElement("div", { className: "order_status_preview__left" },
            React__default.createElement("div", { className: "shimmer_para" })),
        React__default.createElement("div", { className: "order_status_preview__center" },
            React__default.createElement("div", { className: "shimmer_title" }),
            React__default.createElement("div", { className: "shimmer_para" })),
        React__default.createElement("div", { className: "order_status_preview__right" },
            React__default.createElement("div", { className: "shimmer_para" })))); })));
}

export { OrderStatusPreviewShimmer as default };
//# sourceMappingURL=index.shimmer.js.map
